import client from './api-client';

export const serviceGetCfgForm = async (query) => {
    try {
        const response = await client.get(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
export const serviceGetSolicitudes = async(query) => {
    try {
        
        const response = await client.getSelect(`informe-profesional/solicitudes?q=${query}`);      
        
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch(error){
        throw error;
    }
}
export const serviceGetDocumento = async(query) => {
    try {
        const response = await client.getDoc(`get-file?q=${query}`);      

        if (response.status === 200 && response.data.code === 1) return response.data
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}